import { Menu, Bell } from "lucide-react";
import "./header.css";
import { useNavigate } from "react-router-dom";

export default function Header({ onMenuClick }) {
  const navigate = useNavigate();

  return (
    <div className="rp-header-container">
      <div className="rp-header-left">
        <div className="rp-header-title-row">
          <Menu className="rp-header-menu-btn" onClick={onMenuClick} />
          <h2>Dashboard</h2>
        </div>
        <p>Welcome back, Sarah! Here's your lead overview.</p>
      </div>

      <div className="rp-header-right">
        <div onClick={()=>navigate('/push-notification')} className="rp-header-notification">
          <Bell size={20} />
          <span className="rp-header-dot"></span>
        </div>

        <button
          onClick={() => navigate("/leads/create")}
          className="rp-header-create-btn"
        >
          + Create Lead
        </button>
      </div>
    </div>
  );
}
